// extracted by mini-css-extract-plugin
export default {"layout":"KgMXuYjN"};